import React from 'react';
import { ShoppingBag, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = ({ language }) => {
  const content = {
    en: {
      title: 'Everything in One Place,',
      subtitle: 'At Reasonable Prices!',
      description: 'Your trusted neighborhood store in Jamkhambhalia offering up to 50% OFF on a wide range of products',
      cta: 'Explore Products',
      offer: 'UP TO',
      discount: '50% OFF'
    },
    gu: {
      title: 'બધું એક જ જગ્યા પર,',
      subtitle: 'એકદમ વ્યાજબી ભાવે!',
      description: 'જામખંબાળીયામાં તમારો વિશ્વાસુ પડોશી સ્ટોર, વિવિધ ઉત્પાદનો પર 50% સુધીનું ડિસ્કાઉન્ટ',
      cta: 'ઉત્પાદનો જુઓ',
      offer: 'UP TO',
      discount: '50% OFF'
    }
  };

  const t = content[language];

  return (
    <section id="home" className="relative bg-gradient-to-br from-yellow-50 to-red-50 py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 animate-fade-in">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-semibold">
              <Sparkles className="h-4 w-4" />
              {language === 'en' ? 'Grand Opening Offers' : 'ઉદઘાટન ઑફર્સ'}
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              {t.title}
              <br />
              <span className="text-red-600">{t.subtitle}</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-red-600 hover:bg-red-700 text-white text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
              >
                <ShoppingBag className="mr-2 h-5 w-5" />
                {t.cta}
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-red-600 text-red-600 hover:bg-red-50 text-lg px-8 py-6 rounded-lg transition-all duration-300"
                onClick={() => window.open('https://wa.me/919924086184', '_blank')}
              >
                {language === 'en' ? 'Contact Us' : 'સંપર્ક કરો'}
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-red-600 rounded-3xl p-8 shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="bg-white rounded-2xl p-12 text-center">
                <div className="mb-4">
                  <p className="text-red-600 font-bold text-2xl">{t.offer}</p>
                </div>
                <div className="text-7xl font-black text-gray-900 mb-4">{t.discount}</div>
                <div className="text-gray-600 text-lg">
                  {language === 'en' ? 'On Selected Items' : 'પસંદ કરેલી વસ્તુઓ પર'}
                </div>
                <div className="mt-6">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_6d311a70-d8b2-4827-b078-6b13ef0b245b/artifacts/8obibit1_877d2277-d452-4124-a4ed-703d70df9d23.jpeg" 
                    alt="U-MART" 
                    className="h-24 mx-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};